import { render } from "./CRMstatistics.vue?vue&type=template&id=e4c69ed0&scoped=true"
import script from "./CRMstatistics.vue?vue&type=script&lang=js"
export * from "./CRMstatistics.vue?vue&type=script&lang=js"

import "./CRMstatistics.vue?vue&type=style&index=0&id=e4c69ed0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4c69ed0"

export default script